import { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Divider,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Alert,
  Snackbar,
  Paper,
  Button
} from "@mui/material";

import { MdOutlineModeEdit } from "react-icons/md";
import {
  useGetOutOfStockProductsQuery,
  useAddProductQuantityMutation
} from "../../../redux/slices/admin/product/outOfStockSlince.js";
import { useOutletContext, useLocation } from "react-router-dom";
import { Pagination } from "@mui/material";
import "../../../styles/admin.css/products-css/out-of-stock-products.css";

export default function OutOfStockProducts() {
  const { sidebarOpen } = useOutletContext();
  const location = useLocation();
  const highlightId = location.state?.highlightId;
  
  const [page, setPage] = useState(1);
  const itemsPerPage = 50;


  const { data: productsData = [], isLoading, refetch } = useGetOutOfStockProductsQuery();
  const [addProductQuantity] = useAddProductQuantityMutation();
  const products = productsData.data || [];

  useEffect(() => {
    if (highlightId) {
      const product = products.find(p => p.id === highlightId);
      if (product) {
        setOpenRow(product.id);
        setMode("edit");
        window.history.replaceState({}, document.title);
      }
    }
  }, [highlightId, products]);


  const [errors, setErrors] = useState({});
  const [toast, setToast] = useState({ open: false, severity: "success", message: "" });


  const handleCloseToast = () => {
    setToast({ ...toast, open: false });
  };

  const [search, setSearch] = useState("");
  const [openRow, setOpenRow] = useState(null);
  const [mode, setMode] = useState(null);
  const [stockValue, setStockValue] = useState("");

  useEffect(() => {
    refetch();
  }, []);

  const filteredProducts = products.filter((item) =>
    item.name.toLowerCase().includes(search.toLowerCase())
  );

  const totalPages = Math.ceil(filteredProducts.length / itemsPerPage);
  const startIndex = (page - 1) * itemsPerPage;
  const paginatedProducts = filteredProducts.slice(startIndex, startIndex + itemsPerPage);

  const handleEditClick = (prod) => {
    if (openRow === prod.id && mode === "edit") {
      setOpenRow(null);
      setMode(null);
      setStockValue("");
    } else {
      setOpenRow(prod.id);
      setMode("edit");
      setStockValue("");
    }
  };

  const handleStockChange = (value) => {
    if (/^\d*$/.test(value)) {
      setStockValue(value);
    }
  };

  const handleSave = async (id) => {
    if (!stockValue) return setToast({
      open: true,
      severity: "info",
      message: "Miqdar boş ola bilməz!",
    });


    try {
      await addProductQuantity({
        id: id,
        quantity: Number(stockValue)
      }).unwrap();

      setToast({
        open: true,
        severity: "success",
        message: "Miqdar əlavə edildi!",
      });

      setOpenRow(null);
      setMode(null);
      setStockValue("");

      refetch();

    } catch (err) {
      console.log(err);
      setToast({
        open: true,
        severity: "info",
        message: "Xəta baş verdi!",
      });
    }
  };


  const handleCancel = () => {
    setOpenRow(null);
    setMode(null);
    setStockValue("");
  };

  useEffect(() => {
    setPage(1);
  }, [search]);

  return (
    <Box className={`outstock-container ${sidebarOpen ? "sidebar-open" : ""}`}>

      <Box className="outstock-header">
        <Box className="outstock-left-title">
          <Typography style={{ color: "#545A61" }}>
            Bu məhsulların anbar ehtiyatı tükənmişdir.
          </Typography>
          <Divider className="outstock-divider" />
        </Box>

        <TextField
          size="small"
          placeholder="Axtar..."
          className="outstock-search"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </Box>

      <TableContainer component={Paper} className="outstock-table">
        <Table>
          <TableHead>
            <TableRow>
              <TableCell><strong>#No</strong></TableCell>
              <TableCell><strong>Məhsul Adı</strong></TableCell>
              <TableCell><strong>Kateqoriya</strong></TableCell>
              <TableCell><strong>Alt-kateqoriya</strong></TableCell>
              <TableCell><strong>Satış Qiyməti</strong></TableCell>
              <TableCell><strong>Kod</strong></TableCell>
              <TableCell><strong>Yanacaq Növü</strong></TableCell>
              <TableCell><strong>Seçimlər</strong></TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {isLoading ? (
              <TableRow>
                <TableCell colSpan={8} align="center">Yüklənir...</TableCell>
              </TableRow>
            ) : paginatedProducts.length === 0 ? (
              <TableRow>
                <TableCell colSpan={8} align="center">Məlumat tapılmadı</TableCell>
              </TableRow>
            ) : (
              paginatedProducts.map((prod, index) => (
                <>
                  <TableRow key={prod.id} className={highlightId === prod.id ? 'highlight-row' : ''}>
                    <TableCell>
                      {"#" + String(prod.serialNo || prod.id).padStart(4, "0")}
                    </TableCell>

                    <TableCell>{prod.name || "-"}</TableCell>
                    <TableCell>{prod.categoryName || "-"}</TableCell>
                    <TableCell>{prod.subcategoryName || "-"}</TableCell>
                    <TableCell>
                      {prod.sellPrice != null
                        ? `${Number(prod.sellPrice) % 1 === 0 ? Number(prod.sellPrice) : prod.sellPrice}₼`
                        : "-"}
                    </TableCell>
                    <TableCell>{prod.code || "-"}</TableCell>
                    <TableCell>{prod.fuelType || "-"}</TableCell>


                    <TableCell className="manage-wrapper">
                      <Button
                        variant="contained"
                        size="small"
                        className="outstock-btn-edit"
                        onClick={() => handleEditClick(prod)}
                      >
                        <MdOutlineModeEdit style={{ width: "24px", height: "24px" }} />
                      </Button>
                    </TableCell>
                  </TableRow>

                  {openRow === prod.id && mode === "edit" && (
                    <TableRow>
                      <TableCell colSpan={8} className="outstock-expanded-cell">
                        <Box className="outstock-expanded-box">
                          <TextField
                            label="Miqdar"
                            size="small"
                            fullWidth
                            value={stockValue}
                            onChange={(e) => handleStockChange(e.target.value)}
                            margin="dense"
                          />

                          <Box className="outstock-edit-actions">
                            <Button variant="outlined" size="small" onClick={handleCancel}>
                              Ləğv et
                            </Button>
                            <Button
                              variant="contained"
                              size="small"
                              color="primary"
                              onClick={() => handleSave(prod.id)}
                            >
                              Təsdiqlə
                            </Button>
                          </Box>
                        </Box>
                      </TableCell>
                    </TableRow>
                  )}
                </>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>
      {filteredProducts.length > itemsPerPage && (
        <Box sx={{ display: 'flex', justifyContent: 'right', p: 3, mt: 2 }}>
          <Pagination
            count={totalPages}
            page={page}
            onChange={(e, value) => {
              setPage(value);
              window.scrollTo({ top: 0, behavior: 'smooth' });
            }}
            color="primary"
            variant="outlined"
            shape="rounded"
          />
        </Box>
      )}
      <Snackbar
        open={toast.open}
        autoHideDuration={4000}
        onClose={handleCloseToast}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleCloseToast} severity={toast.severity} sx={{ width: '100%' }}>
          {toast.message}
        </Alert>
      </Snackbar>
    </Box>
  );
}